module.exports = __webpack_public_path__ + "img/Armchair.f47176f3.png";